<template>
    <div>
        <div class="profile-style">
            <h5 class="mb-4">Schedule in Event</h5>
            <div class="tabel-action tb-al mb-4 position-relative">
                <div v-if="detail_event.type === 'STANDARD' && detail_event.schedule.length >= 1" class="disabled-feature bdr-15" @click.prevent="$emit('alertPackage')">
                    <i class="uil uil-lock-alt"></i>
                </div>
                <button type="button" v-b-modal.modal-Schedule class="btn bg-white bdr-15 btn-block btn-lg"><i class="uil uil-plus mr-2"></i>Add Schedule</button>
            </div>
            
            <draggable
                v-bind="dragOptions" 
                v-model="scheduleGroup" 
                handle=".handle"
                @start="drag = true"
                @end="drag = false"
                >

                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div v-for="(data,index) in scheduleGroup" :key="data.id" class="link mb-3">
                        <div class="link-drag handle align-items-center d-flex">
                            <i class="uil uil-draggabledots"></i>
                        </div>
                        <div class="link-body">
                            <div class="link-content">
                                <div class="link-item pr-5">
                                    <div><strong>{{data.name}}</strong></div>
                                    <table>
                                        <tr v-if="data.time_start">
                                            <td>Time Start</td>
                                            <td class="pl-2 pr-2">:</td>
                                            <td>{{data.time_start | formatTime}}</td>
                                        </tr>
                                        <tr v-if="data.time_start">
                                            <td>Time End</td>
                                            <td class="pl-2 pr-2">:</td>
                                            <td>
                                                <template v-if="data.time_end ">{{data.time_end | formatTime}}</template>
                                                <template v-if="!data.time_end ">Selesai</template>
                                            </td>
                                        </tr>
                                        <tr v-if="data.time_zone">
                                            <td>Time Zone</td>
                                            <td class="pl-2 pr-2">:</td>
                                            <td>{{data.time_zone}}</td>
                                        </tr>
                                        <tr v-if="data.date">
                                            <td>Date</td>
                                            <td class="pl-2 pr-2">:</td>
                                            <td>{{data.date | formatDate}}</td>
                                        </tr>
                                        <tr v-if="data.location">
                                            <td>Location</td>
                                            <td class="pl-2 pr-2">:</td>
                                            <td>{{data.location}}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="link-switch">
                                    <a href="#" v-b-modal.modal-Schedule v-on:click.prevent="ASSIGN_FORM_SCHEDULE(data)" class="act">
                                        <i class="uil uil-pen"></i>
                                        <span class="link-tx"> Edit</span>
                                    </a>
                                    <a href="#" v-on:click.prevent="alertDelete(data.id,index)" class="act">
                                        <i class="uil uil-trash-alt"></i>
                                        <span class="link-tx"> Delete</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </transition-group>

            </draggable>
        </div>

        <b-modal id="modal-Schedule" size="lg" centered hide-footer :title="modal_title" @hidden="CLEAR_FORM_SCHEDULE">

            <ValidationObserver ref="form">
                <div class="row">
                    <div class="col-md-4">
                        <validation-provider v-if="!formschedule.cover" rules="mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                            <div class="form-group">
                                <div class="mb-1">
                                    <label>Schedule Photo</label>
                                </div>
                                <div class="btn-up d-flex align-items-center" v-on:click.prevent="$refs.inputImage.click()">
                                    <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                </div>
                                <input ref="inputImage" 
                                        type="file"
                                        class="custom-file-input d-none"
                                        id="Thumbnail"
                                        v-on:change="onImageUpload"
                                        accept="image/jpeg,image/png,image/jpg,image/webp" 
                                        @input="validate" >
            
                                <div class="invalid-input mt-3">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                        
                        <div class="form-group" v-if="formschedule.cover">   
                            <div class="mb-1">
                                <label>Schedule Photo</label>
                            </div> 
                            <button v-on:click.prevent="removeImageUpload()" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                            <div class="input-group img-sh">
                                <img :src="formschedule.cover" class="img-responsive img-prf">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Schedule Name</label>
                                <input v-model="formschedule.name" type="text" class="form-control" name="categories">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-6">
                        <label>Time Start</label>
                        <div class="input-group right">
                            <datetime v-model="formschedule.time_start" zone='local' value-zone='local' type="time"  format="HH:mm" input-class="form-control"></datetime>
                            <div class="input-group-prepend" @click="formschedule.time_start = ''">
                                <div class="input-group-text">
                                    <i class="uil uil-times"></i>
                                </div>
                            </div>
                            <small class="pb-3 pt-1">Do not fill in this column if you don't want to show time on schedule</small>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label>Time End</label>
                        <div class="input-group right">
                            <datetime v-model="formschedule.time_end" zone='local' value-zone='local' type="time"  format="HH:mm" input-class="form-control"></datetime>
                            <div class="input-group-prepend" @click="formschedule.time_end = ''">
                                <div class="input-group-text">
                                    <i class="uil uil-times"></i>
                                </div>
                            </div>
                            <small class="pb-3 pt-1">Do not fill in this column if you don't know when the event ends</small>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Time Zone</label>
                            <input v-model="formschedule.time_zone" type="text" class="form-control" name="categories">
                            <small>Example : Wib, Wita, Wit</small>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <label>Event Date</label>
                            <div class="input-group left">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i class="uil uil-calender"></i>
                                    </div>
                                </div>
                                <datetime v-model="formschedule.date" zone='local' value-zone='local' format="dd/MM/yyyy" type="date" input-class="form-control"></datetime>
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>

                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Schedule Location</label>
                            <input v-model="formschedule.location" type="text" class="form-control" name="categories">
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="d-flex">
                            <label class="pl-0 custom-switch switch-big">
                                <input v-model="formschedule.is_multi" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                <span class="custom-switch-indicator"></span>
                            </label>
                            <label class="mt-3 ml-3">
                                <span class="custom-switch-description ml-0"><strong>Is Multi Location</strong></span>
                                <p class="desc">This function is used to display different link maps on every schedule</p>
                            </label>
                        </div>
                    </div>
                    <template v-if="formschedule.is_multi === 'true'">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Location Link</label>
                                <input v-model="formschedule.link_location" type="text" class="form-control" name="categories">
                            </div>
                        </div>
                    </template>

                </div>
              
                <div class="text-right">
                    <button v-on:click="validationForm(formschedule.id)" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                        Save Schedule
                    </button>
                </div>

            </ValidationObserver>

        </b-modal>
    </div>
</template>

<script>

    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver } from "vee-validate";
    import { Datetime } from 'vue-datetime';
    import draggable from 'vuedraggable'
    import moment from 'moment'

    export default{
        data(){
            return{
                drag: false,
                loading:false,
                modal_title : 'Add Schedule',
                photo_file:'',
                cover_file:'',
            }
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
            formatTime: function(val){
                if(val){
                    var time = "2020/02/02 " + val
                    return moment(String(time)).format('HH:mm')
                }else{
                    return '-'
                }
            },
        },
        watch:{
            'formschedule':function(val){
                if(val.id){
                    this.modal_title = 'Edit Schedule'
                }else if(!val.id){
                    this.modal_title = "Add Schedule"
                }
            },
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            draggable,
            Datetime
        },
        computed:{
            ...mapState('EventsControl', {
                detail_event: state => state.detail_event,
                formschedule: state => state.formschedule
            }),

            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            scheduleGroup: {
                get() {
                    return this.detail_event.schedule
                },
                set(value) {
                    this.SET_POSITION_SCHEDULE(value)
                    this.updatePositionSchedule(value)
                }
            }
        },
        methods:{
            ...mapMutations('EventsControl', ['SET_POSITION_SCHEDULE','CLEAR_FORM_SCHEDULE','ASSIGN_FORM_SCHEDULE']),
            ...mapActions('EventsControl', ['detailEvents','createSchedule','updateSchedule','deleteSchedule','updatePositionSchedule']),
            
            onImageUpload: function(event) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.formschedule.cover = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this.cover_file = input.files[0]
            },
            removeImageUpload:function(){
                this.cover_file = ''
                this.formschedule.cover = ''
            },
            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var formData = new FormData();
                        formData.append('id', id ? id : '');
                        formData.append('name', this.formschedule.name ? this.formschedule.name : '');
                        formData.append('location', this.formschedule.location ? this.formschedule.location : '');
                        formData.append('is_multi', this.formschedule.is_multi ? this.formschedule.is_multi : '');
                        formData.append('link_location', this.formschedule.link_location ? this.formschedule.link_location : '');
                        formData.append('frame_location', this.formschedule.frame_location ? this.formschedule.frame_location : '');
                        formData.append('time_start', this.formschedule.time_start ? this.formschedule.time_start : '');
                        formData.append('time_end', this.formschedule.time_end ? this.formschedule.time_end : '');
                        formData.append('time_zone', this.formschedule.time_zone ? this.formschedule.time_zone : '');
                        formData.append('date', this.formschedule.date ? this.formschedule.date : '');
                        formData.append('cover_file', this.cover_file);
                        formData.append('cover', this.formschedule.cover ? this.formschedule.cover : '');
                        
                        if(id){
                            formData.append("_method", "put");
                            this.updateSchedule(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Schedule')
                                this.detailEvents(this.$route.params.id)
                                this.CLEAR_FORM_SCHEDULE()
                                this.$toast.success('Successfully Update Schedule')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.success('Sorry, Something Error')
                            })  
                            
                        }else{

                            this.createSchedule(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Schedule')
                                this.detailEvents(this.$route.params.id)
                                this.CLEAR_FORM_SCHEDULE()
                                this.$toast.success('Successfully Added Schedule')
                            }).catch((error) => {
                                this.loading = false
                                if(error.response.data.errors == 'package'){
                                    this.$toast.warning('Sorry, Upgrade your package to use this feature')
                                }else{
                                    this.$toast.warning('Sorry, Something Error')
                                }
                            })  
                        }
                    }
                });
            },
            alertDelete:function(id,index){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this schedule data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteSchedule(id).then(
                            this.$toast.success('Successfully Deleting Schedule'),
                            this.detail_event.schedule.splice(index, 1)
                        ).catch((error) => {
                            console.log(error)
                            this.$toast.warning('Sorry, Something Error')
                        })
                    }
                })
            },
        }
    }

</script>
